// src/App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Revenue from './pages/Revenue';
import Reviews from './pages/Reviews';
import Valets from './pages/Valets';
import Settings from './pages/Settings';
import ActiveRides from './pages/ActiveRides';
import CustomerDetails from './pages/CustomerDetails';
import Customers from './pages/Customers';
import RideDetails from './pages/RideDetails';
import ValetDetails from './pages/ValetDetails';
import ManageDamages from './pages/Damages';
import Login from './pages/Login';

import './theme.css';
import './App.css';

// simple auth‐guard for v6
function RequireAuth({ children }) {
  const token = localStorage.getItem('@authToken');
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* sidebar only shows when logged in */}
        {localStorage.getItem('@authToken') && <Sidebar />}

        <div className="content">
          <Routes>
            {/* public */}
            <Route path="/login" element={<Login />} />

            {/* protect all other routes */}
            <Route
              path="/*"
              element={
                <RequireAuth>
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/revenue" element={<Revenue />} />
                    <Route path="/reviews" element={<Reviews />} />
                    <Route path="/valets" element={<Valets />} />
                    <Route path="/active_rides" element={<ActiveRides />} />
                    <Route path="/customers" element={<Customers />} />
                    <Route path="/valet/:id" element={<ValetDetails />} />
                    <Route path="/ride/:id" element={<RideDetails />} />
                    <Route path="/customer/:id" element={<CustomerDetails />} />
                    <Route path='/damages' element={<ManageDamages />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="*" element={<h1>404 – Page Not Found</h1>} />
                  </Routes>
                </RequireAuth>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
